export const convertToSafeUrl = (src: string | undefined) => {
    if (!src) return "";
    if (/^\/\//.test(src)) {
        src = `https:${src}`;
    }
    return src;
};